// Bootstrap your Javascript here
// For an example, import your libraries, like jQuery, etc.


try {
    window.$ = window.jQuery = require('jquery');
    require('selectize');
    require('bootstrap-tour/build/js/bootstrap-tour-standalone');
} catch (e) {}
